export const TELEMETRY_OPT_OUT_KEY = 'psb:disable-client-telemetry';

export interface ClientErrorTelemetry {
  message: string;
  stack?: string;
  componentStack?: string;
  timestamp?: string;
}

function redact(value: unknown, maxLength: number): string {
  return String(value || 'Unknown error')
    .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[email]')
    .replace(/Bearer\s+[A-Za-z0-9._~+/-]+/gi, 'Bearer [redacted]')
    .replace(/eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/g, '[token]')
    .replace(/((?:api[_-]?key|access[_-]?token|refresh[_-]?token|password|secret)\s*[:=]\s*)[^\s,;&]+/gi, '$1[redacted]')
    .slice(0, maxLength);
}

export function reportClientError(report: ClientErrorTelemetry): void {
  try {
    if (localStorage.getItem(TELEMETRY_OPT_OUT_KEY) === '1') return;
    fetch('/api/v1/client-errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: redact(report.message, 500),
        stack: report.stack ? redact(report.stack, 4000) : undefined,
        componentStack: report.componentStack ? redact(report.componentStack, 4000) : undefined,
        url: `${window.location.origin}${window.location.pathname}`,
        userAgent: navigator.userAgent.slice(0, 300),
        timestamp: report.timestamp || new Date().toISOString(),
      }),
    }).catch(() => {});
  } catch {
    // Telemetry must never become another application error.
  }
}
